import { icon } from "leaflet";
import React from "react";
import { Marker, Popup } from "react-leaflet";
import { useSelector } from "react-redux";
import { iconLapangan } from "../../../assets";
import arena_olahraga_pt from "../../../data/arena_olahraga_pt.json";

const ArenaOlahraga = () => {
  const ICON = icon({
    iconUrl: iconLapangan,
    iconSize: [32, 32],
  });
  const { stateArenaOlahraga } = useSelector((state) => state);
  return (
    <>
      {stateArenaOlahraga
        ? arena_olahraga_pt.geometries.map((item, index) => (
            <Marker
              key={index}
              icon={ICON}
              position={[
                item.coordinates[1],
                item.coordinates[0],
              ]}
            >
            </Marker>
          ))
        : null}
    </>
  );
};

export default ArenaOlahraga;
